import React from 'react';

import areaValidator from '../area/areaValidator';
import EditForm from './EditForm';
import FormLoader from '../shared/forms/FormLoader';
import PropTypes from 'prop-types';

const ProposalEditor = ({
    editId,
    customerId,
    cancelEdit,
    fetchData
}) => {
    const getUrl = `/api/proposals/edit/${editId}?customerId=${customerId}`;
    const postUrl = '/api/proposals/edit';

    return (
        <FormLoader
            cancelEdit={cancelEdit}
            fetchData={fetchData}
            getUrl={getUrl}
            loadForm={editId !== undefined}
            postUrl={postUrl}
            validator={areaValidator}
        >
            <EditForm cancelEdit={cancelEdit} proposalId={editId} />
        </FormLoader>
    );
}

ProposalEditor.propTypes = {
    cancelEdit: PropTypes.func,
    customerId: PropTypes.number,
    editId: PropTypes.number,
    fetchData: PropTypes.func
};

export default ProposalEditor;